import { Bug } from "@styled-icons/bootstrap";
import { TextInputSetting } from "components/settings";
import { useEffect } from "react";
import Button from "react-bootstrap/Button";
import styled from "styled-components";
import { WidgetFC, WidgetType } from "types/Widget";

interface BlankWidgetState {
  word: string;
}

const BlankWidgetComponent: WidgetFC<BlankWidgetState> = ({
  state: { word },
  setState,
  settings: { title, quote },
}) => {
  function onClicked() {
    setState({ word: word === "Hello" ? "Bye" : "Hello" });
  }

  useEffect(() => {
    return () => {
      console.log("on deleted");
    };
    //Important - make sure this is empty
  }, []);

  return (
    <Container>
      <h3>{title}</h3>
      <h4>{quote}</h4>
      {word}
      <Something />
      <div>
        <Button className="no-drag" onClick={onClicked} variant="primary">
          Change
        </Button>
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding: 1em;
`;

const Something = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30cqw;
  height: 20cqh;
  background: blue;
`;

export const BlankWidget: WidgetType<BlankWidgetState> = {
  name: "Blank",
  component: BlankWidgetComponent,
  icon: Bug,
  showOnToolbar: false,
  sizing: {
    minWidth: 10,
    minHeight: 10,
    minAspectRatio: 1,
    maxAspectRatio: 2,
  },
  defaultState: {
    word: "New!",
  },
  defaultSize: {
    aspectRatio: 1.5,
    widthPercentage: 20,
  },
  settings: {
    title: {
      editor: TextInputSetting,
      info: {
        label: "Title",
        placeholder: "Title here",
      },
      defaultValue: "",
    },
    quote: {
      editor: TextInputSetting,
      info: {
        label: "Quote",
        placeholder: "Here lies a quote",
      },
      defaultValue: "default quote",
    },
  },
};
